"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = IconTooltip;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _utils = require("../../utils");
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    arrow: {
      color: theme.palette.TwClrBaseGray800
    },
    icon: {
      fill: theme.palette.TwClrIcnSecondary,
      marginLeft: '4px',
      marginRight: '4px',
      verticalAlign: 'text-top'
    },
    tooltip: {
      backgroundColor: theme.palette.TwClrBaseGray800,
      color: theme.palette.TwClrBaseWhite,
      padding: '8px',
      '& a': {
        color: theme.palette.TwClrBaseWhite
      }
    }
  };
});
function IconTooltip(_ref) {
  var _ref$iconName = _ref.iconName,
    iconName = _ref$iconName === void 0 ? 'info' : _ref$iconName,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top-start' : _ref$placement,
    title = _ref.title;
  var _React$useState = _react.default.useState(false),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  var _useDeviceInfo = (0, _utils.useDeviceInfo)(),
    isMobile = _useDeviceInfo.isMobile;
  var classes = useStyles();
  var handleTooltipClose = function handleTooltipClose() {
    setOpen(false);
  };
  var handleTooltipOpen = function handleTooltipOpen() {
    setOpen(true);
  };
  return /*#__PURE__*/_react.default.createElement(_material.Tooltip, {
    arrow: true,
    classes: {
      arrow: classes.arrow,
      tooltip: classes.tooltip
    },
    onClose: handleTooltipClose,
    open: isMobile ? open : undefined,
    placement: placement,
    sx: {
      maxWidth: isMobile ? '342px' : '464px'
    },
    title: title
  }, /*#__PURE__*/_react.default.createElement("span", {
    onClick: handleTooltipOpen
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: iconName,
    className: classes.icon
  })));
}